// BUSINESS-MODEL: divisions — lifted VERBATIM from dros-beta-prototype.html.
/* eslint-disable */
// @ts-nocheck
import { todayIso } from '@core/util/date.util';

// Divisions — the company org taxonomy. `code` is the folder
// reference number; entries are declared in code order so every screen (org
// chart, position forms, Company Settings) shows them in that order.
export const DIVISIONS = {
  'CW':  { id:'CW',  code:'101', name:'Company Wide',  process:'', description:'' },
  'OWN': { id:'OWN', code:'102', name:'Owners',  process:'', description:'' },
  'BOD': { id:'BOD', code:'103', name:'BOD',  process:'', description:'Board of Directors.' },
  'IAC': { id:'IAC', code:'104', name:'Internal Audit, Compliance',  process:'', description:'' },
  'CEO': { id:'CEO', code:'105', name:'CEO',  process:'', description:'' },
  'BMM': { id:'BMM', code:'106', name:'Business Model Management', process:'', description:'' },
  'FIN': { id:'FIN', code:'108', name:'Finance & Accounting',  process:'', description:'' },
  'HR':  { id:'HR',  code:'111', name:'HR',  process:'', description:'' },
  'IT':  { id:'IT',  code:'116', name:'IT',  process:'', description:'' },
  'RM':  { id:'RM',  code:'118', name:'Risk Management',  process:'', description:'' },
  'LEG': { id:'LEG', code:'119', name:'Legal',  process:'', description:'' },
  'PCA': { id:'PCA', code:'125', name:'Procurement & Contract Administration', process:'', description:'' },
  'DBG': { id:'DBG', code:'126', name:'Design & BIM Governance', process:'', description:'' },
  'PM':  { id:'PM',  code:'127', name:'Project Management', process:'PMOS', description:'' },
  'CXG': { id:'CXG', code:'128', name:'Client Experience & Growth', process:'', description:'' },
  'CM':  { id:'CM',  code:'130', name:'Construction Management', process:'CMOS',  description:'' },
  'PCE': { id:'PCE', code:'131', name:'Preconstruction & Estimating', process:'', description:'' },
};

// Divisions are the shared, editable company structure — used by the position forms, the People page, and the org chart.
// DIVISIONS is mutated in place so every screen reads one source of truth; editors bump a local rev to re-render.
function nextDivisionCode() {
  let max = 0; Object.values(DIVISIONS).forEach(d => { const n = parseInt(d.code, 10); if (!isNaN(n)) max = Math.max(max, n); });
  return String(max + 1);
}
function addDivisionRec({ name, code, description }) {
  const clean = (name || '').trim(); if (!clean) return null;
  const base = (clean.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 3)) || 'DV';
  let id = base, n = 1; while (DIVISIONS[id]) id = base + (++n);
  DIVISIONS[id] = { id, code: (code || '').trim() || nextDivisionCode(), name: clean, process: '', description: description || '' };
  return id;
}
function renameDivisionRec(id, name) { if (DIVISIONS[id]) DIVISIONS[id] = { ...DIVISIONS[id], name: (name || '') }; }
function updateDivisionRec(id, patch) { if (DIVISIONS[id]) DIVISIONS[id] = { ...DIVISIONS[id], ...patch }; }
function removeDivisionRec(id) { delete DIVISIONS[id]; }
const divisionList = () => Object.values(DIVISIONS);

// Create a Position Catalog record (used when adding a position from the Org Chart, or backfilling a node that has no linked Position).
function addPositionRec({ title, reference, division, tier, pathwayId }) {
  const clean = (title || '').trim(); if (!clean) return null;
  let ref = (reference || '').trim();
  if (!ref) { let max = 0; POSITION_CATALOG.forEach(p => { const m = /^PS\.(\d+)/.exec(p.reference || ''); if (m) max = Math.max(max, +m[1]); }); ref = 'PS.' + (max + 1); }
  const id = 'pc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
  POSITION_CATALOG.push({ id, title: clean, pathwayId: pathwayId || Object.keys(POSITION_PATHWAYS)[0] || 'PM', tier: tier || 'T3', division: division || '', reference: ref, status: 'active', filled: 0, openSeats: 1, summary: '', responsibilities: [], jdIds: [], createdBy: 'org-chart', createdAt: todayIso() });
  return { id, reference: ref };
}
